import "./style.scss";

export function patients_child_hero_block() {
  const block = document.querySelector(".patients_child_hero_block");
  if (!block) return;
}
